import React from 'react'
import "./Process.css";
import Process1 from "../../../../Assets/Images/process1.png";
import Process2 from "../../../../Assets/Images/process2.png";
import Process3 from "../../../../Assets/Images/process3.png";
import Process4 from "../../../../Assets/Images/process4.png";
import Process5 from "../../../../Assets/Images/process5.png";
import partnerIcon from '../../../../Assets/Images/learnmorethumb.png'


export default function Process() {
    return (
        <div className='process'>
            <div className="container">
                <div className="process-top">
                    <h3 className="process-title">
                        Commodities we <span>Process</span>
                    </h3>
                    <img src={partnerIcon} alt="" className="process-icon" />
                </div>
                <ul className="process-list">
                    <li className="process-item">
                        <img src={Process1} alt="" className="process-img" />
                        <h4 className="process-subtitle">
                            Rice
                        </h4>
                        <a href="#" className="process-link">
                            Learn more
                        </a>
                    </li>
                    <li className="process-item">
                        <img src={Process2} alt="" className="process-img" />
                        <h4 className="process-subtitle">
                            Cereals &
                            grains
                        </h4>
                        <a href="#" className="process-link">
                            Learn more
                        </a>
                    </li>
                    <li className="process-item">
                        <img src={Process3} alt="" className="process-img" />
                        <h4 className="process-subtitle">
                            Pulses
                        </h4>
                        <a href="#" className="process-link">
                            Learn more
                        </a>
                    </li>    <li className="process-item">
                        <img src={Process4} alt="" className="process-img" />
                        <h4 className="process-subtitle">
                            Wheat
                        </h4>
                        <a href="#" className="process-link">
                            Learn more
                        </a>
                    </li>
                    <li className="process-item">
                        <img src={Process5} alt="" className="process-img" />
                        <h4 className="process-subtitle">
                            Dryfruits
                        </h4>
                        <a href="#" className="process-link">
                            Learn more
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    )
}
